module.exports = "<app-delivery-banner></app-delivery-banner>\n<app-delivery-details></app-delivery-details>\n<app-delivery-tnc></app-delivery-tnc>"